import Spacings from '@dynatrace/strato-design-tokens/spacings';

export const ITEM_HEIGHT = { value: 20, token: Spacings.Size20 };

export const MIN_ITEM_WIDTH = 120; //px
export const VIRTUALIZED_GRID_THRESHOLD = 50;
export const LEGEND_BUTTON_WIDTH = 50; // Size in pixels of the Legend Button Selector
export const LEGEND_ICON_WIDTH = 25;
export const LEGEND_ACTION_BUTTON_WIDTH = 16; //px

export const LABEL_ITEM_CLASSNAME = 'chart-legend-item-label';
export const CATEGORICAL_LEGEND_CLASS = 'categorical-legend';
